import { Model_AttributeDetailsGet, Model_ProductTypeAttributesGet } from "src/backend/openapi/v1";

export type TSelectedProduct = {
  systemProductConfigurationItemId: string;
  productTypeId: string;
};

// A product type plus the selected products of that type. Attributes carry no rule state, and a value
// only where every one of productIds already holds the same one — otherwise the field opens blank, with
// valuesDiffer saying whether that is because they disagree or because none of them holds a value.
// A write applies to all of productIds.
export type TProductTypeLine = {
  productTypeId: string;
  productTypeName: string;
  productIds: string[];
  attributes: Model_AttributeDetailsGet[];
};

// One line per product type. No unioning needed: definitions come from the type, so every product of
// a type shares one attribute list.
export const buildProductTypeLines = (products: TSelectedProduct[], definitions: Model_ProductTypeAttributesGet[]): TProductTypeLine[] => {
  const definitionByProductTypeId = new Map(definitions.map(entry => [entry.productTypeId, entry]));
  const productsByProductTypeId = new Map<string, TSelectedProduct[]>();

  products.forEach(product => {
    productsByProductTypeId.set(product.productTypeId, [...(productsByProductTypeId.get(product.productTypeId) ?? []), product]);
  });

  return [...productsByProductTypeId.entries()]
    .map(([productTypeId, productsOfType]): TProductTypeLine => {
      const definition = definitionByProductTypeId.get(productTypeId);

      return {
        productTypeId,
        productTypeName: definition?.name ?? "",
        productIds: productsOfType.map(product => product.systemProductConfigurationItemId),
        attributes: definition?.attributes ?? []
      };
    })
    .sort((a, b) => a.productTypeName.localeCompare(b.productTypeName, undefined, { sensitivity: "base" }));
};
